module.exports = __webpack_public_path__ + "static/media/accessory17.ecf80990.webp";